<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/gallery-add.svg" size="2"></app-svg>
  <h1>Create Gallery</h1>
  <form [formGroup]="form" #ngForm="ngForm" [class.submitted]="ngForm.submitted" (ngSubmit)="submit()">
    <app-input-field [control]="form.controls.galleryName">
      <input type="text" formControlName="galleryName" data-test-id="create-gallery-input" appAutofocus />
      <label>Gallery name</label>
    </app-input-field>
    <button
      appButton
      name="confirm"
      location="create-gallery-dialog"
      data-test-id="create-gallery-confirm"
      color="primary"
      height="3"
      size="3"
      weight="bold"
      shape="round"
      spacing="full"
    >
      <span [class.hidden-text]="submitting()">Create Gallery</span>
      @if (submitting()) {
        <app-loading-indicator color="white" size="small" class="button-loading-indicator"></app-loading-indicator>
      }
    </button>
  </form>
</div>
